import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelComponent {
  @Input() id = '';
  @Input() label = '';
  @Input() tooltip = '';
  @Input() required = false;
  @Input() colorLabel: 'black-label' | 'bold-grey-label' | 'bold-black-label' = 'bold-grey-label';

  getLabel(): string {
    if (this.required) {
      return this.label + ' <span class="requiredStar">*</span>';
    }

    return this.label;
  }
}
